<template>
    <div class="app-container">
      <list ref="list">
        <template slot="toolbar-right">
         
        </template>
        <template slot="column">
          
        </template>
      </list>
    
    </div>
  </template>
  <script>
  import curdMixins from "@/mixins/curd";
  import list from "@/components/person/personintegral/demolist";
 
  
  export default {
    name: "personintegral",
    mixins: [curdMixins],
    components: {
      list,
    
    },
    methods: {
      del(id) {
        this.$confirm("确认删除数据吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$refs.list.delRange([id]);
          })
          .catch(() => {});
      },
      delRows() {
        let rows = this.$refs.list.getCheckedRows();
        if (rows.length == 0) {
          this.$message.warning("请选择要删除的数据");
          return;
        }
        this.$confirm("确认删除所选的数据吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let ids = rows.map((item) => {
              return item.RecordId;
            });
            this.$refs.list.delRange(ids);
          })
          .catch(() => {});
      },
    },
  };
  </script>